import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {AuthService} from './auth.service';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from '../modules/admin/services/user.service';


@Injectable({
    providedIn: 'root'
})
export class GuardService extends BaseService implements CanActivate {

    httpOptions;

    constructor(private router: Router, private authService: AuthService, private userService: UserService) {
        super();
        this.httpOptions = authService.getHttpOptions();
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean | UrlTree {

        if (this.checkAuthentication()) {
                return true;
        } else {
            return this.router.parseUrl('/user/login');
        }

    }

    /**
     * Determine if the user is logged by checking the token.
     */
    private checkAuthentication() {

        return (this.authService.isAuthenticated());

    }


}
